import React from "react";
import Image from "next/image";
import CtaOne from "@components/CTA/CtaOne";
import FaqCard from "@components/Cards/FaqCard";
import { BASE_ASSETS_URL } from "../../../constants/constants";
import FAQ2 from "components/CLM/FAQ2";

const faqData = [
  {
    question: "How many signatures can I take?",
    answer: `
      <p>We offer a range of plans designed to suit different needs. Each plan comes with a generous signature quota to ensure you can request as many signatures as you need.</p>
      <p>If you ever find your usage increasing, you can seamlessly upgrade to a higher plan at any time—no interruptions or hidden fees.</p>
      <p>Our goal is to grow with you, so you’ll always have enough signatures to keep your documents moving.</p>
    `,
  },
  {
    question: "Does the recipient need a Google Account?",
    answer: `
      <p>Not at all! We’ve made BoloSign as accessible as possible. Your recipients can open, review, and sign documents using any standard email address.</p>
      <p>They do not need a Google Account (or any other specific provider) to sign. We believe in keeping the signing process hassle-free for everyone involved.</p>
    `,
  },
  {
    question: "What will happen if I run out of signature quota?",
    answer: `
      <p>We understand that business needs can change quickly. If you reach your signature limit, you’ll have the option to top up with additional signatures or upgrade to a higher plan.</p>
      <p>We’ll also send you friendly reminders when you’re approaching your limit so you’re never caught off guard.</p>
    `,
  },
  {
    question: "What will happen to my data if I cancel my subscription?",
    answer: `
      <p>Your data remains safe and accessible even if you decide to cancel.</p>
      <p>We’ll keep your documents stored securely for a grace period (as outlined in our data retention policy), giving you ample time to download or back up anything you need.</p>
      <p>Should you decide to re-subscribe later, your documents will be right where you left them.</p>
    `,
  },
  // {
  //   question: "Fair Usage Policy",
  //   answer: `
  //     <div class="flex flex-col gap-2">
  //     <p>If you're reading this, you're not a small business anymore—congratulations on your success! While our unlimited plans are specifically designed for small businesses (typically between 1-25 employees), small businesses usually operate comfortably within the following limits:</p>
  //     <ul class="list-disc pl-8">
  //       <li>Up to 1200 PDFs per year</li>
  //       <li>Up to 1200 Forms per year</li>
  //       <li>Up to 12,000 Form Responses per year</li>
  //       <li>Up to 1200 PDF Templates per year</li>
  //     </ul>
  //     <p>We also offer tailored solutions for medium and large businesses, maintaining our commitment to being at least 10 times more affordable than providers like DocuSign or PandaDoc.</p>
  //     <p>If you want details on pricing tailored to your company's size or if you're unsure whether your usage fits within our fair use guidelines, please contact us directly at <a href="mailto:support@boloforms.com" class="text-violet-600 underline">support@boloforms.com</a>.</p>

  //     </div>
  //   `,
  // },
  {
    question: "How can I contact support?",
    answer: `
      <p>We’re always here to help. You can reach our friendly support team via:</p>
      <ul class="list-disc pl-5">
      <li><strong>POC:</strong> You can always contact your assigned POC.</li>
     <li><strong>Phone:</strong> <a href="tel:+14156496611" class="text-blue-500">+1 (415) 649-6611</a></li>
      <li><strong>Email:</strong> <a href="mailto:support@boloforms.com" class="text-blue-500">support@boloforms.com</a></li>
        <li><strong>Live Chat:</strong> Available on our website during business hours</li>
        <li><strong>Help Center:</strong> Check out our knowledge base for quick tips and tutorials</li>
      </ul>
      <p>We aim to respond to all inquiries as swiftly as possible, ensuring you get the assistance you need right when you need it.</p>
    `,
  },
  {
    question:
      "Can I add team members or manage multiple users under one account?",
    answer: `
      <p>Yes! We understand the importance of collaboration. BoloSign offers multi-user plans that allow you to:</p>
      <ul class="list-disc pl-5">
        <li>Add team members</li>
        <li>Set permissions</li>
        <li>Manage all user activities under a single workspace</li>
      </ul>
      <p>This centralized approach helps you keep track of documents, signatures, and billing with ease.</p>
      <p>Plus, you can assign different roles or permissions, ensuring everyone has access to exactly what they need.</p>
      <p>If you have a larger team or specific requirements, our sales team is happy to discuss custom solutions tailored to your organization.</p>
    `,
  },
];

const FAQ = () => {
  return (
    <FAQ2
      faqData={faqData}
      heading={"Our Product and Features FAQs"}
      description={
        "We're dedicated to delivering exceptional results, fostering lasting relationships, and ensuring our clients' success in an ever competitive digital marketplace."
      }
    />
  );
};

export default FAQ;
